"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
var WordSentenceStore = /*#__PURE__*/function (_RootStore) {
  function WordSentenceStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, WordSentenceStore);
    _this = _callSuper(this, WordSentenceStore);
    _this.config = {
      model: _models.Sentence,
      deserialize: true,
      GET: {
        index: 'sentences?word_id=:wordId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(WordSentenceStore, _RootStore);
  return (0, _createClass2["default"])(WordSentenceStore, [{
    key: "clearIndexData",
    value: function clearIndexData() {
      this.wordRequest = null;
      this.loadedWordId = null;
      _superPropGet(WordSentenceStore, "clearIndexData", this, 3)([]);
    }
  }, {
    key: "loadForWord",
    value: function loadForWord(wordId, callback) {
      var _this$wordRequest,
        _this$ids,
        _this2 = this;
      if (((_this$wordRequest = this.wordRequest) === null || _this$wordRequest === void 0 ? void 0 : _this$wordRequest.wordId) === wordId) {
        if (callback) this.wordRequest.callbacks.push(callback);
        return;
      }
      if (((_this$ids = this.ids) === null || _this$ids === void 0 ? void 0 : _this$ids.wordId) === wordId && this.loadedWordId === wordId) {
        if (callback) callback(undefined, true);
        return;
      }
      this.clearIndexData();
      var request = {
        wordId: wordId,
        callbacks: callback ? [callback] : []
      };
      this.wordRequest = request;
      var onError = function onError() {
        if (_this2.wordRequest === request) _this2.wordRequest = null;
      };
      this.getIndex({
        ids: {
          wordId: wordId
        },
        queryStrings: {
          vocab_trainer: true
        },
        limit: 10,
        sort: 'level_abbreviation, target_text',
        failureCallback: onError,
        onRequestError: onError
      }, function (resp) {
        if (_this2.wordRequest !== request) return;
        _this2.setIndexData(resp);
        _this2.loadedWordId = wordId;
        _this2.wordRequest = null;
        request.callbacks.forEach(function (cb) {
          return cb(undefined, true);
        });
      });
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new WordSentenceStore();